"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tools = [{
  category: "[ISPEZIONE / VIDEO]",
  name: "Micro-Camera HD",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/ispezione_video_hd.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/ispezione_video_hd.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/ispezione_video_hd.png-wvc-sizes",
  spec: "[SYS-01]",
  spec1Label: "RISOLUZIONE",
  spec1Value: "4K ULTRA",
  spec2Label: "TESTA",
  spec2Value: "360° ROTANTE",
  spec3Label: "CAMPO",
  spec3Value: "HVAC/UTA",
  rationale: "Certificazione tecnica e tecnologia avanzata: Ispezione visiva ad alta definizione per mappare lo stato interno dei condotti e identificare depositi."
}, {
  category: "[ROBOTICA / BONIFICA]",
  name: "Robot Spazzolante",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/robot_spazzolante.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/robot_spazzolante.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/robot_spazzolante.png-wvc-sizes",
  spec: "[SYS-02]",
  spec1Label: "TRAZIONE",
  spec1Value: "4X4 ELETTRICA",
  spec2Label: "AZIONE",
  spec2Value: "MECCANICA",
  spec3Label: "CAMPO",
  spec3Value: "CONDOTTI",
  rationale: "Certificazione tecnica e tecnologia avanzata: Sistema robotizzato per la rimozione meccanica dei depositi solidi in condotti di medie e grandi dimensioni."
}, {
  category: "[ASPIRAZIONE / HEPA]",
  name: "Unità Aspirante HEPA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/unita_aspirante_hepa.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/unita_aspirante_hepa.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/unita_aspirante_hepa.png-wvc-sizes",
  spec: "[SYS-03]",
  spec1Label: "FILTRAZIONE",
  spec1Value: "HEPA H14",
  spec2Label: "PORTATA",
  spec2Value: "5000 M3/H",
  spec3Label: "CAMPO",
  spec3Value: "ESTRAZIONE",
  rationale: "Certificazione tecnica e tecnologia avanzata: Sistema di filtrazione assoluta per garantire che le polveri rimosse non vengano disperse nell'ambiente."
}, {
  category: "[TECNICA / ANALISI]",
  name: "Software di Report",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/software_report_tecnico.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/software_report_tecnico.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/software_report_tecnico.png-wvc-sizes",
  spec: "[SYS-04]",
  spec1Label: "FORMATO",
  spec1Value: "DIGITALE",
  spec2Label: "CONTENUTO",
  spec2Value: "FOTO/VIDEO",
  spec3Label: "CAMPO",
  spec3Value: "VERIFICA",
  rationale: "Certificazione tecnica e tecnologia avanzata: Documentazione tecnica completa con report fotografico prima/dopo per la certificazione dell'intervento."
}, {
  category: "[SPAZZOLE / ROTANTI]",
  name: "Sistema Rotante",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/sistema_spazzole_rotanti.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/sistema_spazzole_rotanti.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/sistema_spazzole_rotanti.webp-wvc-sizes",
  spec: "[SYS-05]",
  spec1Label: "VELOCITÀ",
  spec1Value: "VARIABILE",
  spec2Label: "MATERIALE",
  spec2Value: "NYLON/ACCIAIO",
  spec3Label: "CAMPO",
  spec3Value: "CAPPE",
  rationale: "Certificazione tecnica e tecnologia avanzata: Spazzole rotanti ad alta efficienza per il trattamento tecnico di cappe professionali e reti di estrazione."
}, {
  category: "[STRUMENTI / MISURA]",
  name: "Anemometro Digitale",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/anemometro_digitale.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/anemometro_digitale.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/anemometro_digitale.png-wvc-sizes",
  spec: "[SYS-06]",
  spec1Label: "PRECISIONE",
  spec1Value: "CERTIFICATA",
  spec2Label: "MISURA",
  spec2Value: "PORTATA/VEL",
  spec3Label: "CAMPO",
  spec3Value: "IMPIANTI",
  rationale: "Certificazione tecnica e tecnologia avanzata: Strumentazione di precisione per la verifica delle prestazioni aerauliche post-intervento."
}, {
  category: "[DPI / SICUREZZA]",
  name: "Kit DPI Tecnico",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/kit_dpi_tecnico.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/kit_dpi_tecnico.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/kit_dpi_tecnico.png-wvc-sizes",
  spec: "[SYS-07]",
  spec1Label: "NORMA",
  spec1Value: "UNI EN 149",
  spec2Label: "PROTEZIONE",
  spec2Value: "COMPLETA",
  spec3Label: "CAMPO",
  spec3Value: "OPERATIVO",
  rationale: "Certificazione tecnica e tecnologia avanzata: Dispositivi di protezione individuale per operare in sicurezza in ambienti tecnici confinati."
}, {
  category: "[ANALISI / CAMPIONI]",
  name: "Kit Tamponi",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/kit_tamponi_analisi.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/kit_tamponi_analisi.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/kit_tamponi_analisi.png-wvc-sizes",
  spec: "[SYS-08]",
  spec1Label: "ANALISI",
  spec1Value: "MICROBIOLOGICA",
  spec2Label: "USO",
  spec2Value: "CAMPIONAMENTO",
  spec3Label: "CAMPO",
  spec3Value: "IGIENE",
  rationale: "Certificazione tecnica e tecnologia avanzata: Tamponi per analisi di laboratorio atte a verificare la riqualificazione igienico-funzionale delle superfici."
}];
export default function Diagnostica() {
  const {
    ref: headerRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="1769" id="diagnostica-video-e-robotica" className="relative bg-background text-foreground py-28 md:py-40 overflow-hidden">
      <div aria-hidden="true" className="absolute top-0 left-0 right-0 h-6 opacity-10" style={{
      backgroundImage: "repeating-linear-gradient(45deg, var(--foreground) 0 2px, transparent 2px 6px), repeating-linear-gradient(-45deg, var(--foreground) 0 2px, transparent 2px 6px)"
    }} />

      <div className="max-w-[1360px] mx-auto px-6 md:px-8 lg:px-16">
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-16 md:mb-24 transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <span aria-hidden="true" className="inline-block w-[10px] h-[10px] bg-primary" />
              <span className="font-mono text-xs md:text-sm font-semibold uppercase tracking-[0.18em]">
                § 02 — Diagnostica e Robotica
              </span>
            </div>

            <h2 className="font-default font-black uppercase leading-[0.92] text-[clamp(2.5rem,5.4vw,5rem)] tracking-[-0.015em] text-secondary">
              Tecnologia{" "}
              <em className="not-italic text-secondary">
                Avanzata
              </em>{" "}
              per la Bonifica.
            </h2>
          </div>

          <div className="lg:col-span-4 flex flex-col justify-end gap-5">
            <p className="font-default text-base md:text-lg leading-[1.55] opacity-70">
              Utilizziamo strumentazione di precisione e robotica dedicata per garantire una <strong className="font-bold text-foreground">riqualificazione igienico-funzionale profonda</strong> e radicale, documentata da ispezioni video e report tecnici certificati.
            </p>
            <div className="inline-flex">
              <span className="font-mono text-xs font-semibold uppercase px-2 py-1 border border-primary text-primary tracking-[0.12em]">
                [CERTIFICAZIONE TECNICA]
              </span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[1px] bg-border">
          {tools.map((tool, i) => <article key={i} data-index={i} className="group relative flex flex-col min-h-[380px] bg-card border border-border/40 hover:border-primary/30 transition-colors duration-300">
              <span aria-hidden="true" className="absolute top-2 left-2 w-1.5 h-1.5 rounded-lg z-10 bg-foreground" />
              <span aria-hidden="true" className="absolute top-2 right-2 w-1.5 h-1.5 rounded-lg z-10 bg-foreground" />
              <span aria-hidden="true" className="absolute bottom-2 left-2 w-1.5 h-1.5 rounded-lg z-10 bg-foreground" />
              <span aria-hidden="true" className="absolute bottom-2 right-2 w-1.5 h-1.5 rounded-lg z-10 bg-foreground" />

              <div className="relative h-48 flex items-center justify-center overflow-hidden transition-all duration-300 bg-muted border-b border-border/50 group-hover:shadow-lg group-hover:shadow-primary/5">
                <div aria-hidden="true" className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-primary" />
                <img src={tool.image} data-wvc-srcset={tool.srcset} data-wvc-sizes={tool.sizes} alt={tool.name} loading="lazy" decoding="async" className="relative z-[1] max-h-full max-w-full object-contain p-6 transition-all duration-500 group-hover:scale-105 group-hover:brightness-110 group-hover:contrast-110" />
                <span className="absolute top-3 right-3 z-[2] font-mono text-[0.7rem] font-semibold uppercase px-1.5 py-0.5 transition-colors duration-300 bg-foreground text-background" style={{
              letterSpacing: "0.12em"
            }}>
                  {tool.spec}
                </span>
              </div>

              <div className="flex flex-col flex-1 p-6 gap-4">
                <div className="font-mono text-xs font-semibold uppercase tracking-[0.12em] text-primary">
                  {tool.category}
                </div>

                <h3 className="font-default font-bold uppercase leading-none text-[clamp(1.25rem,1.8vw,1.5rem)] tracking-[-0.005em]">
                  {tool.name}
                </h3>

                <dl className="flex flex-col gap-1.5 pt-3 border-t border-border">
                  <div className="flex justify-between font-mono text-[0.7rem] uppercase">
                    <dt className="text-primary tracking-[0.12em]">
                      {tool.spec1Label}
                    </dt>
                    <dd className="tracking-[0.08em]">
                      {tool.spec1Value}
                    </dd>
                  </div>
                  <div className="flex justify-between font-mono text-[0.7rem] uppercase">
                    <dt className="text-primary tracking-[0.12em]">
                      {tool.spec2Label}
                    </dt>
                    <dd className="tracking-[0.08em]">
                      {tool.spec2Value}
                    </dd>
                  </div>
                  <div className="flex justify-between font-mono text-[0.7rem] uppercase">
                    <dt className="text-primary tracking-[0.12em]">
                      {tool.spec3Label}
                    </dt>
                    <dd className="tracking-[0.08em]">
                      {tool.spec3Value}
                    </dd>
                  </div>
                </dl>

                <div className="mt-auto pt-3">
                  <div className="font-mono text-[0.65rem] font-semibold uppercase mb-1.5 tracking-[0.15em] text-primary">
                    Efficacia Tecnica
                  </div>
                  <p className="font-default text-sm leading-[1.5] opacity-85 text-primary">
                    {tool.rationale}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}